import { ADMIN_TABLE_DEFAULT_PAGE_SIZE } from 'constants/adminTables';

export const DEFAULT_SORT_FIELD = 'emails';
export const ROWS_PER_PAGE_OPTIONS = [ADMIN_TABLE_DEFAULT_PAGE_SIZE]; // Currently DataGrid has a css bug with the rowsPerPageOptions select
